export const TAB_NAME = {
  PRE_BIP: 'Pre BIP',
  BIP: 'BIP',
} as const;
